import React from 'react';
import { useAlertsAutoRefresh } from '../utils/useAlertsAutoRefresh';

/**
 * Global alerts manager that runs in the background to check for new alerts
 * and play notification sounds. This component should be mounted at the app level
 * to ensure it runs regardless of the current page.
 */
const GlobalAlertsManager: React.FC = () => {
  // Enable auto-refresh globally with a unique ID
  useAlertsAutoRefresh(true, 'global-manager');

  // This component doesn't render anything visible
  return null;
};

export default GlobalAlertsManager;
